import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
	selector: 'app-bc-e-blog',
	templateUrl: './bc-e-blog.component.html',
	styleUrls: ['./bc-e-blog.component.scss']
})

export class BcEBlogComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('accountClientID') accountClientID: string = "";
	@Input('isView') isView;
	blog: FormGroup;
	blogContent = [];
	users = [];
	userList = [];
	filteredList = [];
	allSaved = true; //Do some field have some unsaved change?
	private tempElement // Hold the changed Element reference
	private query = '';
	private token;
	private isLoaded = false;

	constructor(private fb: FormBuilder,
		private bcAccountClientService: BcAccountClientService,
		private flashMessagesService: FlashMessagesService) {
		this.blog = fb.group({
			ID: '',
			Nome: '',
			Mensagem: ['', Validators.compose([Validators.required])]
		});
	}

	ngOnInit() {
	}

	loadBlog() {
		if (!this.isLoaded) {
			this.getProposalBlog();
			this.getUsers();
			this.isLoaded = true;
		}
	}

	getProposalBlog() {
		this.bcAccountClientService.getProposalBlog(this.proposalID).subscribe(result => {
			if (result.Success) {
				console.log(result.Result);
				this.blogContent = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	filter(event) {

		this.query = event.target.value;
		this.tempElement = (<HTMLInputElement>document.getElementById("user-name"));
		this.allSaved = false;

		if (this.query !== "") {
			this.filteredList = this.userList.filter(function (el) {
				return el.userName.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
			}.bind(this));
		} else {
			this.filteredList = [];
		}

		if ($("#user-id").val() != "") {
			$("#user-id").val("");
			this.tempElement.value = "";
			this.filteredList = [];
		}
	}

	select(item) {
		this.tempElement.value = item.userName;
		var elementId = this.tempElement = (<HTMLInputElement>document.getElementById("user-id"));
		elementId.value = item.userID;
		this.filteredList = [];
		this.allSaved = true;
	}

	insertBlogComment(blog: any) {

		blog.Area = this.proposalID;
		blog.ContaClienteID = this.accountClientID;
		blog.ParaID = (<HTMLInputElement>document.getElementById("user-id")).value;

		this.bcAccountClientService.insertBlogComment(blog).subscribe(result => {
			if (result.Success) {
				this.getProposalBlog();
				this.blog.reset();
				$("#user-name").val("");
				$("#user-id").val("");
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getUsers() {
		this.bcAccountClientService.getBlogUserList().subscribe(result => {
			this.users = result.Result;
			this.users.forEach(user => {
				this.userList.push({
					userName: user.Nome + " (" + user.Login + ")",
					userID: user.ID
				});
			});
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-blog/bc-e-blog.component.ts